import gql from 'graphql-tag';

import { lessonExerciseFragment } from '~/shared/graphql-queries/lesson-exercises/index';

export default gql`
  mutation updateByIdLessonExerciseMutation(
    $_id: MongoID!
    $record: UpdateByIdLessonExerciseInput!
  ) {
    updateByIdLessonExerciseMutation(_id: $_id, record: $record) {
      recordId
      record {
        ...LessonExerciseFragment
      }
      message
      title
    }
  }
  ${lessonExerciseFragment}
`;
